export { default as JobMetrics } from "./JobMetrics";

// functions for mounting job metrics in non-Vue environments
export { mountJobMetrics } from "./mount";
